import { render, staticRenderFns } from "./Retorno.vue?vue&type=template&id=041311b4"
import script from "./Retorno.vue?vue&type=script&lang=js"
export * from "./Retorno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports